import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'

import Pagination from '@components/Pagination'
import FilterGroup from '@components/FilterGroup'
import { Typeahead } from '@components/Autocomplete'
import ParentAccountList from './ParentAccountList'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import Expert from '@components/Icon/Expert'
import MyProjects from '@components/Icon/MyProjects'
import { SearchPanelContainer } from '@components/Search'
import { StatusFilter } from '@components/StatusFilter'

class SearchPanel extends Component {
  static propTypes = {
    clientRecordsSearchStore: PropTypes.object,
    modalStore: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    props.clientRecordsSearchStore.search()
  }

  filterCategories = selectedCategory => {
    this.props.clientRecordsSearchStore.activeTab = selectedCategory[0]
  }

  search = keyword => {
    this.props.clientRecordsSearchStore.search(keyword)
    this.props.clientRecordsSearchStore.changePage(1)
  }

  onRefresh = () => {
    this.props.clientRecordsSearchStore.clearSearch()
    this.search('')
  }

  renderItem = item => {
    return (
      <div>
        <div>{item && item.name}</div>
        <div>
          <span>{this.renderItemIcon(item.type)}</span>
          <span>{item.type.toUpperCase()}</span>
        </div>
      </div>
    )
  }

  renderItemIcon = type => {
    if (type === 'account') return <MyProjects />
    if (type === 'project') return <ProjectsIcon />
    if (type === 'employee') return <Expert className='employee' />
    return null
  }

  render () {
    const { clientRecordsSearchStore } = this.props
    const {
      records,
      query,
      activeTab,
      total,
      autocompleteInput,
      autocompleteClientRecords,
      statusOptions
    } = clientRecordsSearchStore

    return (
      <SearchPanelContainer
        wide
        buttonProps={{
          dataCy: 'create-parent-account-btn',
          buttonText: 'Create Parent Account',
          onClick: () =>
            this.props.modalStore.show({
              type: 'PARENT_ACCOUNT_FORM',
              props: {
                onSaveSuccess: parentAccount => {
                  this.props.history.push('/parent-account/' + parentAccount.id)
                  this.props.modalStore.close()
                }
              }
            })
        }}
        searchTitle='Search Client Records'
        onClearSearch={this.onRefresh}
      >
        <FilterGroup
          label='Company name or location'
          onSearch={() => this.search(autocompleteInput)}
        >
          <Typeahead
            value={autocompleteInput}
            loadOptions={autocompleteClientRecords}
            onChange={selectedRecord => {
              clientRecordsSearchStore.autocompleteInput = selectedRecord
              this.search(selectedRecord)
            }}
            onInputValueChange={inputValue => {
              clientRecordsSearchStore.autocompleteInput = inputValue
            }}
          />
        </FilterGroup>
        <div className='client-records'>
          <StatusFilter
            single
            required
            selectedItems={[activeTab]}
            items={statusOptions}
            onChange={this.filterCategories}
          />
        </div>
        <div>
          <ParentAccountList
            parentAccounts={records}
            activeTab={activeTab}
            clientRecordsSearchStore={this.props.clientRecordsSearchStore}
          />
          <Pagination
            total={total}
            perPage={10}
            page={query.page}
            onChange={p => this.props.clientRecordsSearchStore.changePage(p)}
          />
        </div>
      </SearchPanelContainer>
    )
  }
}

export default inject('modalStore')(withRouter(observer(SearchPanel)))
